/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { detectAdBlock, PUBLIC_DOMAIN, setCookieWithExpiry } from "../../utils/providers";
import { usePublicConfig } from "../../hooks/usePublicConfig";
import { DEV_ENV } from "../../utils";

const ReferrerProvider = ({ children }) => {
  const { env } = usePublicConfig();
  const { search, hash } = useLocation();
  const [cookies, setCookie] = useCookies([
    "_C2C_REFERER",
    "_C2C_REFERER_QUERY",
  ]);

  useEffect(() => {
    const { referrer } = document;
    const isPublic = referrer.includes(PUBLIC_DOMAIN);
    const hasRefCookie = Boolean(cookies._C2C_REFERER);
    const hasQueryCookie = Boolean(cookies._C2C_REFERER_QUERY);
    const currentQueryString = `${search}${hash}`;

    if (referrer && !isPublic && !hasRefCookie) {
      setCookieWithExpiry(setCookie, "_C2C_REFERER", referrer);
    }

    const setQueryCookie = (query) => {
      setCookieWithExpiry(setCookie, "_C2C_REFERER_QUERY", query);
    };

    const handleAdBlockCheck = async () => {
      const adBlockDetected = await detectAdBlock();

      if (!hasQueryCookie || cookies._C2C_REFERER_QUERY === "adb=1") {
        const query = adBlockDetected
          ? currentQueryString
            ? `${currentQueryString}&adb=1`
            : "adb=1"
          : currentQueryString;

        if (query) {
          setQueryCookie(query);
        }
      }
    };

    if (!DEV_ENV?.includes(env?.hostEnv)) {
      handleAdBlockCheck();
    }
  }, [search, hash, cookies]);

  return children;
};

export default ReferrerProvider;
